import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { pdf } from "@react-pdf/renderer";
import FeesStructurePDF9 from "./FeesStructurePdf9";
import CryptoJS from "crypto-js";

function FeesStructure9() {
  const [tableData, setTableData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [isPreviewed, setIsPreviewed] = useState(false);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryaccountstoken");
  const [class9DeveloperMode, setClass9DeveloperMode] = useState("");

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/FetchConfigurationData`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-Private-Key": tokeng,
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          const configData = data?.data;
          setClass9DeveloperMode(configData.cL_9_DEVELOPER_MODE);
        } else {
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }
    };

    fetchConfigData();

    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  //  FETCH DATA
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.API_BASE_URL}/FetchFeesStructure_CL9`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setTableData(data.data?.feesStructureData_list || []);
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //  SEND EMAIL
  const sendEmail = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const pdfBlob = await pdf(
        <FeesStructurePDF9 tableData={tableData} />
      ).toBlob();
      const pdfFile = new File([pdfBlob], "Class-IX-Fees-Structure.pdf", {
        type: "application/pdf",
      });

      // 1st Email
      const formData1 = new FormData();
      if (class9DeveloperMode === "NO") {
        formData1.append("To", "itcell.jac@gmail.com");
        formData1.append("Bcc", "parikshadata@gmail.com");
      } else {
        formData1.append("To", "sumit@cludotechnology.in");
        formData1.append("Bcc", "prosenjit.maji@cludotechnology.in");
      }
      formData1.append("Subject", "Updated Fees Structure - CLASS IX");
      formData1.append(
        "Message",
        "Please find attached the updated Class IX Fees Structure PDF."
      );
      formData1.append("Attachments", pdfFile);

      const response1 = await fetch(`${config.API_BASE_URL}/SendMail1`, {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: formData1,
      });

      const data1 = await response1.json();

      if (!(response1.ok && (data1.success || data1.status === "ok"))) {
        Swal.fire("Error", data1.message || "Failed to send email.", "error");
        return false;
      }

      // 2nd Email
      // const formData2 = new FormData();
      // if (class9DeveloperMode === "NO") {
      //   formData2.append("TO", "parikshadata@gmail.com");
      // } else {
      //   formData2.append("TO", "nilotpal@cludotechnology.in");
      // }
      // formData2.append("SUBJECT", "Updated Fees Structure - CLASS IX");
      // formData2.append(
      //   "MESSAGE",
      //   "Please find attached the updated Class IX Fees Structure PDF."
      // );
      // formData2.append("ATTACHMENTS", pdfFile);

      // const response2 = await fetch(`${config.API_BASE_URL}/SendMail1`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     "X-Private-Key": tokeng,
      //   },
      //   body: formData2,
      // });

      // const data2 = await response2.json();

      // if (!(response2.ok && (data2.success || data2.status === "ok"))) {
      //   Swal.fire(
      //     "Error",
      //     data2.message || "Failed to send 2nd email.",
      //     "error"
      //   );
      //   return false;
      // }
    } catch (error) {
      console.error("Error sending email:", error.message);
      Swal.fire("Error", error.message || "Something went wrong", "error");
      return false;
    }
  };

  //  HANDLE INPUT
  const handleInputChange = (e, key, index) => {
    const value = e.target.value;
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    const newData = [...tableData];
    newData[index][key] = value;

    const odppm = parseFloat(newData[index].odppM_FEE) || 0;
    const reg1 = parseFloat(newData[index].registratioN_FEE_1) || 0;
    const reg2 = parseFloat(newData[index].registratioN_FEE_2) || 0;
    const permission = parseFloat(newData[index].permissioN_FEE) || 0;
    const exam = parseFloat(newData[index].examinatioN_FEE) || 0;
    const late = parseFloat(newData[index].latE_FEE) || 0;

    const beforeLateTotal = odppm + reg1 + reg2 + permission + exam;
    const afterLateTotal = beforeLateTotal + late;

    newData[index].beforE_LATE_TOTAL_FEE = beforeLateTotal.toFixed(2);
    newData[index].afteR_LATE_TOTAL_FEE = afterLateTotal.toFixed(2);

    setTableData(newData);
  };

  //  PREVIEW
  const handleClickPreview = () => {
    const hasEmpty = tableData.some(
      (item) =>
        !item.odppM_FEE ||
        !item.registratioN_FEE_1 ||
        !item.registratioN_FEE_2 ||
        !item.permissioN_FEE ||
        !item.examinatioN_FEE ||
        !item.latE_FEE
    );

    if (hasEmpty) {
      Swal.fire(
        "Validation Error",
        "All fields are mandatory. If any field is blank, set 0.",
        "warning"
      );
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(true);
      setLoading(false);
    }, 500);
  };
  // EDIT
  const handleClickEdit = () => {
    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(false);
      setLoading(false);
    }, 500);
  };

  //  UPDATE FEES
  const handleUpdateClick = async () => {
    const hasEmpty = tableData.some(
      (item) =>
        !item.odppM_FEE ||
        !item.registratioN_FEE_1 ||
        !item.registratioN_FEE_2 ||
        !item.permissioN_FEE ||
        !item.examinatioN_FEE ||
        !item.latE_FEE
    );

    if (hasEmpty) {
      Swal.fire(
        "Validation Error",
        "All fields are required. Please fill in all values.",
        "warning"
      );
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to edit it once submitted",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = tableData.map((item) => ({
          autoCode: item.autO_CODE,
          odppmFee: item.odppM_FEE || 0,
          beforeLateRegistrationFee: item.registratioN_FEE_1 || 0,
          afterLateRegistrationFee: item.registratioN_FEE_2 || 0,
          permissionFee: item.permissioN_FEE || 0,
          examinationFee: item.examinatioN_FEE || 0,
          beforeLateTotalFee: item.beforE_LATE_TOTAL_FEE || 0,
          lateFee: item.latE_FEE || 0,
          afterLateTotalFee: item.afteR_LATE_TOTAL_FEE || 0,
        }));

        try {
          setLoading(true);
          const response = await fetch(`${config.API_BASE_URL}/UpdateFeesCl9`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });

          const data = await response.json();
          if (response.ok) {
            Swal.fire(
              "Success",
              "Fees structure updated successfully!",
              "success"
            ).then(async () => {
              await handleDownload();
              await sendEmail();
              await fetchData();
            });
          } else {
            Swal.fire(
              "Error",
              data.message || "Something went wrong.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error updating fees:", error);
          Swal.fire("Error", "Something went wrong while updating.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  //  DOWNLOAD PDF
  const handleDownload = async () => {
    try {
      const blob = await pdf(
        <FeesStructurePDF9 tableData={tableData} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Class-IX-Fees-Structure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: "File has been downloaded successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("PDF download failed:", error);
      Swal.fire("Error", "Something went wrong while downloading", "error");
    }
  };

  //  RENDER
  return (
    <div className="container-scroller">
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-1">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-inr"></i>&nbsp; Class IX Fees Structure
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        href="accounts-dashboard"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/secondary-accounts-dashboard-class-ix");
                        }}
                      >
                        Home&nbsp;
                      </a>
                    </li>
                    <li className="active"> Class IX Fees Structure</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {tableData.length > 0 &&
                      tableData.some(
                        (item) => item.updatE_STATUS === "YES"
                      ) && (
                        <div className="d-flex justify-content-end p-2">
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={() => handleDownload()}
                          >
                            <i className="fa fa-download me-1"></i> Download Pdf
                          </button>
                        </div>
                      )}

                    <div className="table-responsive">
                      <table className="table table-hover table-bordered mb">
                        <thead>
                          <tr className="table-info">
                            <th>#</th>
                            <th>Candidate Category</th>
                            <th>Gender</th>
                            <th>ODPPM Fee</th>
                            <th>Registration Fee 1</th>
                            <th>Registration Fee 2</th>
                            <th>Permission Fee</th>
                            <th>Examination Fee</th>
                            <th>Before Late Total Fee</th>
                            <th>Late Fee</th>
                            <th>After Late Total Fee</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.length > 0 ? (
                            tableData.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.candidatE_TYPE}</td>
                                <td>{item.candidatE_CATEGORY}</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.odppM_FEE || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, "odppM_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.registratioN_FEE_1 || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "registratioN_FEE_1",
                                        index
                                      )
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.registratioN_FEE_2 || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "registratioN_FEE_2",
                                        index
                                      )
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.permissioN_FEE || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "permissioN_FEE",
                                        index
                                      )
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.examinatioN_FEE || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        "examinatioN_FEE",
                                        index
                                      )
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.beforE_LATE_TOTAL_FEE || ""}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.latE_FEE || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, "latE_FEE", index)
                                    }
                                    disabled={
                                      item.updatE_STATUS === "YES" ||
                                      isPreviewed
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm text-right"
                                    value={item.afteR_LATE_TOTAL_FEE || ""}
                                    disabled
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="11"
                                className="text-center text-muted"
                              >
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="11" className="text-end">
                              {tableData.length > 0 &&
                                (tableData.some(
                                  (item) => item.updatE_STATUS === "YES"
                                ) ? (
                                  <p className="text-danger text-center mt-3">
                                    Fees Structure already updated. Changes are
                                    not allowed.
                                  </p>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <marquee className="fomarquee">
                                      Fees Structure can only be updated once.
                                      No further changes will be applicable
                                      after submitting.
                                    </marquee>

                                    {isPreviewed ? (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-warning btn-sm ms-2"
                                          onClick={handleClickEdit}
                                        >
                                          <i className="fa fa-edit me-1"></i>
                                          Edit
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm ms-2"
                                          onClick={handleUpdateClick}
                                        >
                                          <i className="fa fa-save"></i>
                                          &nbsp;Submit
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-info btn-sm ms-2"
                                        onClick={handleClickPreview}
                                      >
                                        <i className="fa fa-eye me-1"></i>
                                        Preview
                                      </button>
                                    )}
                                  </div>
                                ))}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default FeesStructure9;
